const autocompleteModalAction = {
  user: 'Accountables',
  helperText: 'Maximum quantity of responsible parties:',
};

export default autocompleteModalAction;
